import React, { Component, FC } from 'react';
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';

interface CrashViewState {
  hasError: boolean;
}

interface CrashViewProps extends WithTranslation {
  children: any;
}

const CrashViewReturnHomeButton: FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <Button
      type="primary"
      onClick={() => {
        navigate('/');
        navigate(0);
      }}
    >
      {t('ReturnHome')}
    </Button>
  );
};

class CrashView extends Component<CrashViewProps, CrashViewState> {
  constructor(props: CrashViewProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_: any) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    // You can also log the error to an error reporting service
    console.clear();
    console.error('============= SEND FROM HERE 👇🏻👇🏻👇🏻 ===============');
    console.error(error);
    console.error(errorInfo);
    console.error('============= SEND TO HERE 👆🏻👆🏻👆🏻 ===============');
  }

  render() {
    const { t } = this.props;
    if (this.state.hasError) {
      return (
        <div className="planit-general-error-container">
          <Result status={500} title={t('CrashError')} subTitle={`${t('SeeAllLogs')}`} extra={<CrashViewReturnHomeButton />} />
        </div>
      );
    }

    return this.props.children;
  }
}

export default withTranslation()(CrashView);
